import { defineMessages } from 'react-intl';

export default defineMessages({
	csmRequestsListBannerText: {
		defaultMessage: 'My requests',
		description: 'Text for the banner in the csm requests list page',
		id: 'hub.csm.requests.list.banner.text.non-final',
	},
	customizeMenuLabel: {
		id: 'hub.routes.customize-menu.label',
		defaultMessage: 'Customize',
		description:
			'Accessible label for the customize dropdown menu trigger button in the hub header.',
	},
	manageListViewButtonLabel: {
		id: 'hub.routes.jsm-requests-list.manage-list-view.button.label',
		defaultMessage: 'Manage list view',
		description:
			'Label for the menu item in the customize dropdown that opens the manage columns sidebar on the JSM requests list page.',
	},
	loginAnnouncementButtonLabel: {
		id: 'hub.routes.homepage.login-announcement.button.label',
		defaultMessage: 'Add login page message',
		description: 'Label for the Hub Customize menu item that opens login announcement settings.',
	},
	helpCenterSectionHeading: {
		id: 'hub.routes.customize-menu.help-center-section.heading',
		defaultMessage: 'Help center',
		description:
			'Heading for the group of the customize dropdown holding the site-wide help center entry points, which are the same on every page.',
	},
	editHelpCenterLabel: {
		id: 'hub.routes.customize-menu.edit-help-center.label',
		defaultMessage: 'Edit help center',
		description:
			'Label for the customize dropdown menu item that opens the help center home page in the editor.',
	},
	editPortalPageLabel: {
		id: 'hub.routes.customize-menu.edit-portal-page.label',
		defaultMessage: 'Edit portal page',
		description:
			'Label for the customize dropdown menu item that opens the current portal page in the editor.',
	},
	editPortalAnnouncementLabel: {
		id: 'hub.routes.customize-menu.edit-portal-announcement.label',
		defaultMessage: 'Edit portal announcement',
		description:
			'Label for the customize dropdown menu item that opens the current portal page in the editor, shown to sites without Premium, where the announcement is the only part of a portal page they can change.',
	},
	editCustomPageLabel: {
		id: 'hub.routes.customize-menu.edit-custom-page.label',
		defaultMessage: 'Edit custom page',
		description:
			'Label for the customize dropdown menu item that opens the current custom page in the editor.',
	},
	viewAllHelpCentersLabel: {
		id: 'hub.routes.customize-menu.view-all-help-centers.label',
		defaultMessage: 'View all help centers',
		description:
			'Label for the customize dropdown menu item that opens the help center management screen.',
	},
	createHelpCenterLabel: {
		id: 'hub.routes.customize-menu.create-help-center.label',
		defaultMessage: 'Create help center',
		description:
			'Label for the customize dropdown menu item that opens the help center management screen with its create flow open.',
	},
	createCustomPageLabel: {
		id: 'hub.routes.customize-menu.create-custom-page.label',
		defaultMessage: 'Create custom page',
		description:
			'Label for the customize dropdown menu item that opens the editor on the help center home page with the create page dialog open.',
	},
	premiumLozenge: {
		id: 'hub.routes.customize-menu.premium-lozenge',
		defaultMessage: 'Premium',
		description:
			'Lozenge marking a customize menu item as a Premium feature, shown to sites that are not entitled to it.',
	},
	rovoAgentLabel: {
		id: 'hub.routes.customize-menu.rovo-agent.label',
		defaultMessage: 'Rovo agent',
		description:
			"Label for the customize dropdown menu item that opens the help center's Rovo agent settings.",
	},
});
